// extracted by mini-css-extract-plugin
export default {"header":"header---t4dFI","headerCell":"headerCell---o85rz"};